import React from 'react'
import {ShowGuesser} from '@api-platform/admin'
import {TextField, BooleanField} from 'react-admin';
import {useTranslation} from "react-i18next";

function Show(props) {
    const {t} = useTranslation()
    return (
        <ShowGuesser {...props}>
            <TextField source="originId" label={t('id')}/>
            <TextField source="name" label={t('common.name')}/>
            <TextField source="sid" label={'sid'}/>
            <BooleanField source="isData" label={t('admin.isData')}/>
        </ShowGuesser>
    )
}

export default Show
